var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dj-view-absolute",style:({width:_vm.width,height:_vm.height}),on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }